import type { StateCreator } from 'zustand';
import type { PrescriptionAssistantSliceType } from '../types';

export const updatePrescriptionPadDispenseNote: StateCreator<
  PrescriptionAssistantSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (dispenseNote: string) => void
> = (set) => (dispenseNote) =>
  set(
    (state) => {
      state.prescriptionAssistant.prescriptionPad.dispenseNote = dispenseNote;
    },
    false,
    'prescriptionPad/setDispenseNote'
  );
